import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { i18n } from '../../translate/i18n';
import { fetchUserService, fetchValidUsersService, fetchUsersExportService } from '../../services/users';
import siteObjectToQuery from "../../utils/siteObjectToQuery";

let CancelToken = axios.CancelToken;
let fetchUsersByTenant_cancel;
let fetchUserById_cancel;

export const fetchUsersSuccess = (users) => {
  return {
    type: actionTypes.FETCH_USERS_SUCCESS,
    users: users
  };
};

export const setUsersFilter = (pageUser, limitUser, searchText, orderUser, orderByUser, role) => {
  return {
    type: actionTypes.SET_USERS_FILTER,
    usersFilter: {
      pageUser, limitUser, searchText, orderUser, orderByUser, filteredRoles: role
    }
  };
};

export const removeUsersRolesFilter = (role) => {
  return {
    type: actionTypes.REMOVE_USERS_ROLES_FILTER,
    role,
  }
};

export const requestUsersFail = (error) => {
  return {
    type: actionTypes.REQUEST_USERS_FAIL,
    error: error
  };
};


export const fetchUsersInvitationsSuccess = (usersInvitations) => {
  return {
    type: actionTypes.FETCH_USERS_INVITATIONS_SUCCESS,
    usersInvitations: usersInvitations
  };
};

export const requestUsersInvitationsStart = () => {
  return {
    type: actionTypes.REQUEST_USERS_INVITATIONS_START
  };
};

export const requestUsersInvitationsFail = (error) => {
  return {
    type: actionTypes.REQUEST_USERS_INVITATIONS_FAIL,
    error: error
  };
};


export const requestUsersStart = () => {
  return {
    type: actionTypes.REQUEST_USERS_START
  };
};


export const requestUpdateUsersBySuperadminStart = () => {
  return {
    //REQUEST_USERS_START REQUEST_UPDATE_USER_BY_SUPERADMIN_START
    type: actionTypes.REQUEST_UPDATE_USER_BY_SUPERADMIN_START
  };
};

export const requestUpdateUsersBySuperadminFail = () => {
  return {
    type: actionTypes.REQUEST_UPDATE_USER_BY_SUPERADMIN_FAIL
  };
};


export const updateUsersBySuperadminSuccess = () => {
  return {
    type: actionTypes.UPDATE_USER_BY_SUPERADMIN_SUCCESS,
  };
};

export const deleteUsersSuccess = (user) => {
  return {
    type: actionTypes.DELETE_USERS_SUCCESS,
    user: user
  }
}

export const inviteSignupSuccess = () => {
  return {
    type: actionTypes.INVITE_SIGNUP_SUCCESS,
  }
}

export const inviteSignupByTenantSuccess = () => {
  return {
    type: actionTypes.INVITE_SIGNUP_BY_TENANT_SUCCESS,
  }
}

export const updateUsersSuccess = (user) => {
  return {
    type: actionTypes.UPDATE_USERS_SUCCESS,
    user: user
  }
}

export const postUsersSuccess = (user) => {
  return {
    type: actionTypes.POST_USERS_SUCCESS,
    user: user
  }
}

export const fetchUserByIdSuccess = user => {
  return {
    type: actionTypes.FETCH_USER_BY_ID_SUCCESS,
    user: user
  }
}

export const inviteAddTenatSuccess = () => {
  return {
    type: actionTypes.INVITE_ADD_TENANT_SUCCESS,
  }
}

export const inviteCreateUserSuccess = () => {
  return {
    type: actionTypes.INVITE_CREATE_USER_SUCCESS,
  }
}

export const forgotPasswordSuccess = () => {
  return {
    type: actionTypes.FORGOT_PASSWORD_SUCCESS,
  }
}

export const forgotPasswordActivateSuccess = () => {
  return {
    type: actionTypes.FORGOT_PASSWORD_ACTIVATE_SUCCESS,
  }
}

export const getTokenConfirmAddTenantOrUserSuccess = (userToken) => {
  return {
    type: actionTypes.GET_TOKEN_CONFIRM_ADD_TENANT_OR_USER,
    userToken: userToken
  }
}

export const setUsersRolesFilter = (roles) => {
  return {
    type: actionTypes.SET_USERS_ROLES_FILTER,
    roles,
  }
};

export const fetchUsers = (page, limit, search, order, orderBy, sites, role) => {
  return dispatch => {
    dispatch(requestUsersStart());
    dispatch(setUsersFilter(page, limit, search, order, orderBy, role));
    fetchUserService(page, limit, search, order, orderBy, sites, role)
      .then(res => {
        dispatch(fetchUsersSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestUsersFail(err));
      });
  };
};

export const fetchUsersInvitations = (page, limit, search, order, orderBy, sites) => {
  return dispatch => {
    dispatch(requestUsersInvitationsStart());
    let queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    queryParams += `&${sites && sites.length > 0 ? 'sites=' + siteObjectToQuery(sites) : ''}`;
    API.get('/users/invitations' + queryParams)
      .then(res => {
        dispatch(fetchUsersInvitationsSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestUsersInvitationsFail(err));
      });
  };
};


//users that are not superadmin and are active for this token
export const fetchValidUsers = (page, limit, search, order, orderBy) => {
  return dispatch => {
    dispatch(requestUsersStart());
    fetchValidUsersService(page, limit, search, order, orderBy)
      .then(res => {
        dispatch(fetchUsersSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestUsersFail(err));
      });
  };
};

export const fetchUserById = (id) => {
  fetchUserById_cancel && fetchUserById_cancel()
  return dispatch => {
    dispatch(requestUsersStart());
    API.get('/users/' + id, {
      cancelToken: new CancelToken(function executor(c) {
        fetchUserById_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchUserByIdSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestUsersFail(err));
      });
  };
};


export const fetchUserByIdBySuperadmin = (id, tenantId) => {
  fetchUserById_cancel && fetchUserById_cancel()
  return dispatch => {
    dispatch(requestUsersStart());
    API.get('/users/' + id + '/by_superadmin/' + tenantId, {
      cancelToken: new CancelToken(function executor(c) {
        fetchUserById_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchUserByIdSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestUsersFail(err));
      });
  };
};


export const deleteUsers = (index, page, limit, search, order, orderBy) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestUsersStart());
      API.delete('/users/' + index + '/access')
        .then(res => {
          dispatch(deleteUsersSuccess(res.data));
          dispatch(fetchUsers(page, limit, search, order, orderBy));
          resolve('success');
        })
        .catch(err => {
          dispatch(requestUsersFail(err));
        });
    })
  }
}

export const postUsers = (body, page, limit, search, order, orderBy) => {
  return dispatch => {
    dispatch(requestUsersStart());
    API.post('/users', body)
      .then(res => {
        dispatch(postUsersSuccess(res.data));
        dispatch(fetchUsers(page, limit, search, order, orderBy));
      })
      .catch(err => {
        dispatch(requestUsersFail(err));
      });
  }
}

export const updateUsers = (index, body, page, limit, search, order, orderBy) => {
  return dispatch => {
    dispatch(requestUsersStart());
    API.put('/users/' + index, body)
      .then(res => {
        dispatch(updateUsersSuccess(res.data));
        dispatch(fetchUsers(page, limit, search, order, orderBy));
      })
      .catch(err => {
        dispatch(requestUsersFail(err));
      });
  }
}

export const fetchUsersByTenant = (tenantId, page, limit, search, order, orderBy) => {
  fetchUsersByTenant_cancel && fetchUsersByTenant_cancel();
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestUsersStart());
      const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
      API.get('tenants/' + tenantId + '/users' + queryParams, {
        cancelToken: new CancelToken(function executor(c) {
          fetchUsersByTenant_cancel = c;
        })
      })
        .then(res => {
          dispatch(fetchUsersSuccess(res.data));
          resolve('success');
        })
        .catch(err => {
          dispatch(requestUsersFail(err));
          reject('error');
        });
    });
  };
};

export const inviteSignup = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      //requestUsersInvitationsStart 
      dispatch(requestUpdateUsersBySuperadminStart());
      API.post('/users/invitesignup', body)
        .then(res => {
          //fetchUsersInvitationsSuccess 
          dispatch(updateUsersBySuperadminSuccess());
          toastr.success(i18n.t('inviteSignup.toastr'), i18n.t('inviteSignup.toastr1'))
          resolve('success');
        })
        .catch(err => {
          //requestUsersInvitationsFail 
          dispatch(requestUpdateUsersBySuperadminFail(err));
          if (err.response.data.message) {
            toastr.error('Erro', err.response.data.message);
          } else {
            toastr.error('Erro', err.response);
          }
          resolve('error');
        });
    })
  }
}

export const inviteSignupBySuperAdmin = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestUpdateUsersBySuperadminStart());
      API.post('/users/invitesignup_by_superadmin', body)
        .then(res => {
          dispatch(updateUsersBySuperadminSuccess());
          toastr.success(i18n.t('inviteSignupBySuperAdmin.toastr'), i18n.t('inviteSignupBySuperAdmin.toastr1'))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestUpdateUsersBySuperadminFail(err));
          if (err.response.data.message) {
            toastr.error('Erro', err.response.data.message);
          } else {
            toastr.error('Erro', err.response);
          }
          resolve('error');
        });
    })
  }
}

export const updateUserAccess = (userIndex, accessIndex, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestUsersStart());
      API.put('/users/' + userIndex + '/access/' + accessIndex, body)
        .then(res => {
          dispatch(updateUsersSuccess(res.data));
          toastr.success(i18n.t('updateUserAccess.toastr'), `${res.data.name}${i18n.t('updateUserAccess.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestUsersFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('updateUserAccess.toastrError'), i18n.t('updateUserAccess.toastrError'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}

export const updateUserAccessBySuperadmin = (userIndex, accessIndex, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestUpdateUsersBySuperadminStart());
      API.put('/users/' + userIndex + '/access_by_superadmin/' + accessIndex, body)
        .then(res => {
          dispatch(updateUsersBySuperadminSuccess());
          toastr.success(i18n.t('updateUserAccessBySuperadmin.toastr'), `${res.data.name}${i18n.t('updateUserAccessBySuperadmin.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestUpdateUsersBySuperadminFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('updateUserAccessBySuperadmin.toastrError'),i18n.t('updateUserAccessBySuperadmin.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}

export const inviteAddTenant = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestUsersStart());
      API.post('/users/inviteaddtenant', body)
        .then(res => {
          dispatch(inviteAddTenatSuccess());
          toastr.success(i18n.t('inviteAddTenant.toastr'),i18n.t('inviteAddTenant.toastr1'))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestUsersFail(err));
          resolve({ error: 'error', code: err?.response?.data?.code || '' });
        });
    })
  }
}

export const inviteCreateUser = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestUsersStart());
      API.post('/users/invitecreateuser', body)
        .then(res => {
          dispatch(inviteCreateUserSuccess());
          toastr.success(i18n.t('inviteCreateUser.toastr'), i18n.t('inviteCreateUser.toastr1'))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestUsersFail(err));
          resolve({ error: 'error', code: err?.response?.data?.code || '' });
        });
    })
  }
}

export const forgotPassword = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestUsersStart());
      API.post('/users/forgotPassword', body)
        .then(res => {
          dispatch(forgotPasswordSuccess());
          toastr.success(i18n.t('forgotPassword.toastr'), i18n.t('forgotPassword.toastr1'))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestUsersFail(err));
          toastr.error('Erro', err.response)
          resolve('error');
        });
    })
  }
}

export const forgotPasswordActivate = (tokenId, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestUsersStart());
      API.post('/users/forgotpasswordactivate/' + tokenId, body)
        .then(res => {
          dispatch(forgotPasswordActivateSuccess());
          toastr.success(i18n.t('forgotPasswordActivate.toastr'), i18n.t('forgotPasswordActivate.toastr1'))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestUsersFail(err));
          toastr.error('Erro', err.response)
          resolve('error');
        });
    })
  }
}

export const clearUsersFilter = () => {
  return {
    type: actionTypes.CLEAR_USERS_FILTER,
  }
};

// export
export const fetchUsersExport = (search, order, orderBy, sites, filteredPlaces, filteredModels, filteredGroups, filteredAreas, emailLanguage) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      fetchUsersExportService(search, order, orderBy, sites, filteredPlaces, filteredModels, filteredGroups, filteredAreas, emailLanguage)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          toastr.error('Erro', err)
          reject(err);
        });
    });
  };
};
